import React from 'react';

import DonationDeleteModal from '@/core/components/DonationDeleteModal';
import ScrollDownItem from '@/core/components/ScrollDownItem';
import useDisclosure from '@/core/hooks/useDisclosure';
import { FinishAction } from '@/core/lib/new-architecture/domain/donation.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface FinishSecondaryActionComponentProps {
  action: FinishAction;
}

const FinishSecondaryActionComponent: React.FC<FinishSecondaryActionComponentProps> = ({ action }) => {
  const { t } = useTranslationContext(['common']);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onClickDivParent: React.MouseEventHandler<HTMLDivElement> = event => {
    const isTargetDivElement = event.target instanceof HTMLDivElement;
    const isTargetParagraphElement = event.target instanceof HTMLParagraphElement;
    const isTargetSVGElement = event.target instanceof SVGSVGElement;
    if (isTargetDivElement || isTargetParagraphElement || isTargetSVGElement) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    // eslint-disable-next-line
    <div role="dialog" onClick={onClickDivParent}>
      <ScrollDownItem type="button" icon="trash" content={t(action.text, { ns: 'common' })} onClick={onOpen} disabled={action.isDisabled} />
      <DonationDeleteModal isOpen={isOpen} closeModal={onClose} donationId={action.donationId} />
    </div>
  );
};

export default FinishSecondaryActionComponent;
